const state = {
  categories: {},
  categoryOptions: [],
  units: {},
  unitsByType: {},
  unitOptions: [],
  unitOptionsByType: {
    volume: [],
    weight: [],
    count: [],
    length: [],
    custom: []
  }
};
const getters = {
  inventoryCategories: state => state.categories,
  inventoryCategoryOptions: state => state.categoryOptions,
  getUnits: state => state.units,
  getUnitOptions: state => state.unitOptions,
  getUnitsByType: state => state.units,
  getUnitOptionsByType: state => state.unitOptionsByType,
};
const actions = {
  
};
const mutations = {
  setInventoryCategories(state, obj) {
    state.categories = obj
  },
  setInventoryCategoryOptions(state, arr) {
    state.categoryOptions = arr
  },
  setUnits(state, obj) {
    state.units = obj
  },
  setUnitOptions(state, arr) {
    state.unitOptions = arr
  },
  setUnitsByType(state, [obj, type]) {
    state.unitsByType[type] = obj
  },
  setUnitOptionsByType(state, [arr, type]) {
    state.unitOptionsByType[type] = arr
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};